export const COMPONENT_TYPE = {
  TICKET: 'Ticket',
}
